<template>
    <modal centered="true" @closed="$emit('cancelled')">
        <h5 class="t-font-bold" slot="title">
            Update fuel adjustment multiplier
        </h5>

		<loading-alert v-if="loading"></loading-alert>

		<form v-else class="t-bg-white t-rounded t-px-8 t-pt-6 t-pb-8" @submit.prevent="submitForm" autocomplete="off">
			<div class="t-mb-4">
				<label class="t-block t-text-gray-700 t-text-sm t-font-bold t-mb-2" for="multiplier-input">Multiplier</label>
				<div class="t-flex">
					<input v-bind:class="{ 'is-invalid': errors.has('multiplier') }"
						name="multiplier"
						v-validate.disable="'required|decimal'"
						id="multiplier-input"
						type="text"
						class="t-bg-gray-200 t-appearance-none t-border-2 t-border-gray-200 t-w-full t-rounded t-py-2 t-px-4 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-purple-500"
						v-model="multiplier"
						placeholder="1.00"
						autocomplete="off">
						<span class="t-bg-gray-200 t-py-2 t-px-4 t-rounded">%</span>
				</div>
					<div v-show="errors.has('multiplier')" class="t-bg-red-100 t-text-sm t-w-full t-border-red-400 t-text-red-700 t-px-4 t-py-3 t-my-3 t-rounded">
						Please enter a numeric multiplier
					</div>
			</div>
			<div class="t-flex t-items-center t-justify-end t-pt-4">
				<button @click="$emit('cancelled')" type="button" class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline" data-dismiss="modal">
					Close
				</button>
				<button :disabled="saving" type="submit" class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline">
					<i v-if="saving" class="fa fa-spinner fa-spin"></i>
					<span v-else>Update</span>
				</button>
			</div>
		</form>
    </modal>
</template>

<script>
    import Modal from '../../utils/Modal';
	import LoadingAlert from '../../utils/LoadingAlert';

    export default {
        name: 'fuel-adjustment-form',
        components: { Modal, LoadingAlert },
		$_veeValidate: {
			validator: 'new'
		},
		props: ['value'],
        data() {
            return {
                loading: true,
				multiplier: "",
				saving: false
            }
        },

		mounted() {
			if (!this.value) {
				this.loadCurrentMultiplier();
			} else {
				this.multiplier = this.value;
				this.loading = false;
			}
		},

        methods: {
			loadCurrentMultiplier() {
				this.loading = true;

				axios.get('/carry-freight/settings/fuel-multiplier')
					 .then(response => {
						 this.multiplier = response.data.fuel_adjustment_multiplier;
						 this.loading = false;
					 })
					 .catch(error => {
						 Event.$emit('serverError');
						 this.loading = false;
						 this.$emit('cancelled');
					 });
			},

			submitForm() {
				this.$validator.validateAll().then(res => {
					if (res) {
						this.saving = true;

						axios.patch('/carry-freight/settings/fuel-multiplier', {
							'fuel-multiplier': this.multiplier
						}, { headers: { Accept: 'application/json' } })
						.then(response => {
							this.$emit('submitted');
							this.$swal({
								title: "Fuel adjustment multiplier updated!",
								type: "success",
								confirmButtonText: 'Okay',
							});
						})
						.catch(error => {
							Event.$emit('serverError');
							this.$emit('cancelled');
						});
					}
				});
			}
        },

		watch: {
            "multiplier": function () {
                if(this.fields.multiplier) {
                    this.$validator.validate('multiplier');
                }
            }
		}
    }
</script>